<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="showzx"
      :close-on-click-modal="false"
      width="25%"
      top="25vh"
      :modal="false"
    >
      <el-form ref="form" :model="zixun">
        <el-form-item>
          <el-input
            placeholder="  请输入公司名"
            prefix-icon="el-icon-user-solid"
            v-model="zixun.mGongsi"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="  请输入联系人"
            prefix-icon="el-icon-user-solid"
            v-model="zixun.mName"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
            placeholder=" 手机号（必填）"
            prefix-icon="el-icon-user-solid"
            v-model="zixun.mPhone"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
            style="width: 70%"
            placeholder=" 验证码"
            prefix-icon="el-icon-phone"
            v-model="zixun.mYzm"
            @blur="tocheck"
          >
          </el-input>
          <i
            v-if="isshowCheck"
            :style="
              'margin:0 2%;font-size:18px;position: absolute;left: 60%;top: 12px;color:' +
              (yzmOK == true ? 'green;' : 'red;')
            "
            :class="yzmOK ? 'el-icon-circle-check' : 'el-icon-circle-close'"
          ></i>
          <el-button
            style="width: 30%"
            type="success"
            @click="SendMsM"
            plain
            v-bind:disabled="issend == true"
            >{{ issend ? "(" + lastTime + "S)" : "获取验证码" }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="  请输入邮箱"
            prefix-icon="el-icon-monitor"
            v-model="zixun.mMail"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            required
            placeholder="  请输入联系地址"
            prefix-icon="el-icon-position"
            v-model="zixun.mAddress"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendZX()">发 送</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { saveZixun, sendMsM, checkMsM, getLKUrl } from "@/api/index";
export default {
  name: "ZIXUN",
  props: {
    showzx: Boolean,
  },
  data() {
    return {
      zixun: {},
      lastTime: 0,
      issend: false,
      sign: "",
      yzmOK: false,
      isshowCheck: false,
    };
  },
  methods: {
    tocheck() {
      const params = new URLSearchParams();
      params.append("phone", this.zixun.mPhone);
      params.append("code", this.zixun.mYzm);
      params.append("sign", this.sign);
      checkMsM(params)
        .then((e) => {
          if (e.data == true) {
            this.yzmOK = true;
            this.isshowCheck = true;
          }
        })
        .catch((e) => {
          this.yzmOK = false;
          this.isshowCheck = true;
        });
    },
    SendMsM() {
      var phone = this.zixun.mPhone;
      if (
        phone == undefined ||
        phone == null ||
        this.isPoneAvailable(phone) == false
      ) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请输入正确的手机号",
          duration: 2000,
          showClose: true,
        });
        return false;
      }
      const params = new URLSearchParams();
      params.append("phone", phone);

      //发送
      sendMsM(params).then((e) => {
        this.sign = e.msg;
        this.$notify({
          type: "success",
          title: "温馨提示",
          message: "发送成功，注意查收",
          duration: 5000,
          showClose: true,
        });
        this.issend = true;
        this.lastTime = 60;
        var int = self.setInterval((e) => {
          this.lastTime = this.lastTime - 1;
          if (this.lastTime == 0) {
            this.issend = false;
            clearTimeout(int);
          }
        }, 1000);
      });
    },
    isPoneAvailable($poneInput) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test($poneInput)) {
        return false;
      } else {
        return true;
      }
    },
    GetUrlParam(paraName) {
      var url = window.location.href.toString();
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    sendZX() {
      const params = new URLSearchParams();
      if (this.zixun.mName == null || this.zixun.mName == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写联系人",
          duration: 1000,
          showClose: true,
        });
        return;
      }
          if (this.zixun.mYzm == null || this.zixun.mYzm == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写验证码",
          duration: 1000,
          showClose: true,
        });
        return;
      }
      if (
        this.zixun.mPhone == undefined ||
        this.zixun.mPhone == null ||
        this.isPoneAvailable(this.zixun.mPhone) == false
      ) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请输入正确的手机号",
          duration: 2000,
          showClose: true,
        });
        return false;
      }
      params.append("adminId", this.GetUrlParam("qiyeId"));
      params.append("mName", this.zixun.mName!=undefined?this.zixun.mName:'');
      params.append("mGongsi", this.zixun.mGongsi!=undefined?this.zixun.mGongsi:'');
      params.append("mMail", this.zixun.mMail!=undefined?this.zixun.mMail:'');
      params.append("mPhone", this.zixun.mPhone!=undefined?this.zixun.mPhone:'');
      params.append("mAddress", this.zixun.mAddress!=undefined?this.zixun.mAddress:'');
      params.append("mProduct", window.location.href.toString());
      params.append("code", this.zixun.mYzm);
      params.append("type", this.GetUrlParam("type"));

      params.append("sign", this.sign);
      saveZixun(params).then((e) => {
        if (this.GetUrlParam("type") == "LK") {
           var data = JSON.parse(e.msg);
          if (data.code != 20000) {
            this.$notify({
              type: "error",
              title: "温馨提示",
              message: data.msg,
              duration: 5000,
              showClose: true,
            });
            this.dialogVisible = false;
            return ;
          }
          var num = data.num;
          var username = data.username;
          var password = data.password;
          this.$alert(
            "已生产您的体验账号：【公司编号: " +
              num +
              "】,【登录账号: " +
              username +
              "】,【登录密码: " +
              password +
              "】",
            "注册成功",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                //跳转
                //获取冷库地址
                getLKUrl().then((ee) => {
                  window.open(
                    ee.msg +
                      `/csms/kehuAdmin/doLoginTest?kehu=${num}&m_num=${username}&m_password=${password}`
                  );
                });
              },
            }
          );
        }
        this.$notify({
          type: "success",
          title: "温馨提示",
          message: "发送成功，我们会尽快与您取得联系",
          duration: 5000,
          showClose: true,
        });

        this.dialogVisible = false;
      }).catch(es=>{
          this.$notify({
          type: "error",
          title: "温馨提示",
          message: es,
          duration: 5000,
          showClose: true,
        });
      });
    },
  },
};
</script>
